// card
import view from '../../../Enums';

let key;

var WhyJoinCardStyles = {};

var centerAbs = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translateY(-50%) translateX(-50%)'
};

var horiCenterAbs = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)'
};

WhyJoinCardStyles['parent_card_why_oyo'] = {};
WhyJoinCardStyles['parent_card_why_oyo'][view.MOBILE] = {
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  boxShadow: '0 10px 20px -10px rgba(157, 157, 157, 0.14)',
  overflow: 'hidden',
  padding: '17px 0px'
};
WhyJoinCardStyles['parent_card_why_oyo'][view.DESKTOP] = {
  ...centerAbs,
  width: '280px',
  borderRadius: '8px',
  boxShadow: '0 10px 20px -10px rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  height: '345px',
  textAlign: 'center',
  overflow: 'hidden',
  padding: '17px 0px'
};

WhyJoinCardStyles['why_oyo_img'] = {};
WhyJoinCardStyles['why_oyo_img'][view.MOBILE] = {
  width: '138px',
  height: '138px',
  margin: '16px 55px 24px'

  // marginLeft:'55px',
  // marginRight:'55px',
  // marginTop:'16px'
};
WhyJoinCardStyles['why_oyo_img'][view.DESKTOP] = {
  marginTop: '24px',
  marginBottom: '24px',
  width: '138px',
  height: '138px',
  objectFit: 'contain'
};

WhyJoinCardStyles['why_oyo_heading'] = {};
WhyJoinCardStyles['why_oyo_heading'][view.MOBILE] = {
  marginBottom: '8px',
  height: '24px',
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#231815',
  fontFamily: 'InterphaseMedium'
};
WhyJoinCardStyles['why_oyo_heading'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#231815',
  fontFamily: 'InterphaseMedium'
};

WhyJoinCardStyles['why_oyo_content'] = {};
WhyJoinCardStyles['why_oyo_content'][view.MOBILE] = {
  width: '86%',
  marginLeft: '16px',
  marginRight: '16px',
  height: '102px',
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
WhyJoinCardStyles['why_oyo_content'][view.DESKTOP] = {
  padding: '0px 30px',
  height: '85px',
  marginTop: '8px',
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};

WhyJoinCardStyles['why_oyo_learn_more'] = {};
WhyJoinCardStyles['why_oyo_learn_more'][view.MOBILE] = {
  marginBottom: '16px',
  height: '21px',
  fontFamily: 'InterphaseMedium',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#1ab64f'
};
WhyJoinCardStyles['why_oyo_learn_more'][view.DESKTOP] = {
  marginTop: '16px',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#1ab64f'
};

export var WhyJoinCardStyles;

var SelectionCardStyles = {};

SelectionCardStyles['selection_card_parent'] = {};
SelectionCardStyles['selection_card_parent'][view.MOBILE] = {
  position: 'relative',
  borderRadius: '2px'
};
SelectionCardStyles['selection_card_parent'][view.DESKTOP] = {
  position: 'relative',
  borderRadius: '2px'
};

SelectionCardStyles['tick_style'] = {};
SelectionCardStyles['tick_style'][view.MOBILE] = {
  position: 'absolute',
  height: '20px',
  width: '20px',
  top: '0',
  transform: 'translateX(40%) translateY(-40%)',
  right: '0'
};
SelectionCardStyles['tick_style'][view.DESKTOP] = {
  position: 'absolute',
  height: '20px',
  width: '20px',
  top: '0',
  transform: 'translateX(40%) translateY(-40%)',
  right: '0'
};

SelectionCardStyles['central_div_selection_card'] = {};
SelectionCardStyles['central_div_selection_card'][view.MOBILE] = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
  //padding: '3px'
};
SelectionCardStyles['central_div_selection_card'][view.DESKTOP] = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
  // padding: '3px'
};

SelectionCardStyles['hotel_icon'] = {};
SelectionCardStyles['hotel_icon'][view.MOBILE] = {
  position: 'relative',
  height: '20px',
  width: '20px',
  //marginRight: '10px',
  marginLeft: '16px',
  marginTop: '2px'
};
SelectionCardStyles['hotel_icon'][view.DESKTOP] = {
  position: 'relative',
  height: '20px',
  width: '20px',
  //marginRight: '10px',
  marginLeft: '16px',
  marginTop: '2px'
};

SelectionCardStyles['house_icon'] = {};
SelectionCardStyles['house_icon'][view.MOBILE] = {
  position: 'relative',
  height: '16px',
  width: '20px',
  // marginRight: '10px',
  marginLeft: '16px',
  //marginTop: '5px'
  marginTop: '4px'
};
SelectionCardStyles['house_icon'][view.DESKTOP] = {
  position: 'relative',
  height: '16px',
  width: '20px',
  // marginRight: '10px',
  marginTop: '4px',
  marginLeft: '16px'
};

SelectionCardStyles['info_icon'] = {};
SelectionCardStyles['info_icon'][view.MOBILE] = {
  height: '18px',
  width: '18px',
  // marginTop: '6px',
  marginRight: '10px',
  marginTop: '4px'
  //backgroundColor: "#000000",
};
SelectionCardStyles['info_icon'][view.DESKTOP] = {
  height: '18px',
  width: '18px',
  // marginTop: '6px',
  marginTop: '4px',
  marginRight: '10px'
  // marginRight: '10px'
};

SelectionCardStyles['type_text_selection_card'] = {};
SelectionCardStyles['type_text_selection_card'][view.MOBILE] = {
  position: 'absolute',
  opacity: '0.87',
  fontSize: '14px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  marginLeft: '46px',
  marginTop:'2px'
};
SelectionCardStyles['type_text_selection_card'][view.DESKTOP] = {
  position: 'absolute',
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  marginLeft: '46px'
};

export var SelectionCardStyles;

// revenue component style
var revenueStyles = {};

revenueStyles['revenueMainContainer'] = {};
revenueStyles['revenueMainContainer'][view.MOBILE] = {
  margin: '7px'
};
revenueStyles['revenueMainContainer'][view.DESKTOP] = {
  margin: '7px'
};

revenueStyles['bedroomsAndIconANDRoomContainer'] = {};
revenueStyles['bedroomsAndIconANDRoomContainer'][view.MOBILE] = {
  display: 'flex',
  boxSizing: 'border-box',
  fontSize: '1.25rem',
  fontFamily: 'InterphaseMedium',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: '400'
};
revenueStyles['bedroomsAndIconANDRoomContainer'][view.DESKTOP] = {
  display: 'flex',
  boxSizing: 'border-box',
  fontSize: '1.25rem',
  fontFamily: 'InterphaseMedium',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: '400'
};

revenueStyles['bedroomAndIconContainer'] = {};
revenueStyles['bedroomAndIconContainer'][view.MOBILE] = {
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box'
};
revenueStyles['bedroomAndIconContainer'][view.DESKTOP] = {
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box'
};

revenueStyles['bedroomText'] = {};
revenueStyles['bedroomText'][view.MOBILE] = {
  marginLeft: '20px',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: 'rgb(136, 136, 136)'
};
revenueStyles['bedroomText'][view.DESKTOP] = {
  marginLeft: '20px',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: 'rgb(136, 136, 136)'
};

revenueStyles['arrowsAndRoomsContainer'] = {};
revenueStyles['arrowsAndRoomsContainer'][view.MOBILE] = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
};
revenueStyles['arrowsAndRoomsContainer'][view.DESKTOP] = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
};

revenueStyles['leftArrow'] = {};
revenueStyles['leftArrow'][view.MOBILE] = {
  border: 'solid green',
  borderWidth: '0 4px 4px 0',
  display: 'inline-block',
  padding: '5px',
  transform: 'rotate(135deg)'
};
revenueStyles['leftArrow'][view.DESKTOP] = {
  border: 'solid green',
  borderWidth: '0 4px 4px 0',
  display: 'inline-block',
  padding: '5px',
  transform: 'rotate(135deg)'
};

revenueStyles['rightArrow'] = {};
revenueStyles['rightArrow'][view.MOBILE] = {
  border: 'solid green',
  borderWidth: '0 4px 4px 0',
  display: 'inline-block',
  padding: '5px',
  transform: 'rotate(-45deg)'
};
revenueStyles['rightArrow'][view.DESKTOP] = {
  border: 'solid green',
  borderWidth: '0 4px 4px 0',
  display: 'inline-block',
  padding: '5px',
  transform: 'rotate(-45deg)'
};

revenueStyles['numberOfRooms'] = {};
revenueStyles['numberOfRooms'][view.MOBILE] = {
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  padding: '0px 4px',
  width: '55px',
  textAlign: 'center',
  outline: 'none',
  fontSize: '19px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgb(0, 0, 0)'
};
revenueStyles['numberOfRooms'][view.DESKTOP] = {
  borderRadius: '2px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  padding: '0px 4px',
  width: '55px',
  textAlign: 'center',
  outline: 'none',
  fontSize: '23px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgb(0, 0, 0)'
};

revenueStyles['amountContainer'] = {};
revenueStyles['amountContainer'][view.MOBILE] = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '45px',
  marginTop: '11px'
};
revenueStyles['amountContainer'][view.DESKTOP] = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '38px',
  marginTop: '11px'
};

revenueStyles['amount'] = {};
revenueStyles['amount'][view.MOBILE] = {
  marginLeft: '7px',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgb(0, 0, 0)',
  fontFamily: 'InterphaseBold'
};
revenueStyles['amount'][view.DESKTOP] = {
  marginLeft: '7px',
  fontSize: '20px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: 'rgb(0, 0, 0)',
  fontFamily: 'InterphaseBold'
};

revenueStyles['rev_earned'] = {};
revenueStyles['rev_earned'][view.MOBILE] = {
  top: '6.5px',
  fontSize: '12px',
  color: 'rgb(201, 203, 207)',
  textTransform: 'uppercase',
  display: 'inlineBlock',
  marginLeft: '5px',
  fontWeight: '800'
};
revenueStyles['rev_earned'][view.DESKTOP] = {
  top: '6.5px',
  fontSize: '12px',
  color: 'rgb(201, 203, 207)',
  textTransform: 'uppercase',
  display: 'inlineBlock',
  marginLeft: '5px',
  fontWeight: '800'
};

revenueStyles['perYear'] = {};
revenueStyles['perYear'][view.MOBILE] = {
  fontSize: '12px',
  color: '#c9cbcf',
  textTransform: 'uppercase',
  display: 'inline-block',
  marginLeft: '5px'
};
revenueStyles['perYear'][view.DESKTOP] = {
  fontSize: '12px',
  color: '#c9cbcf',
  textTransform: 'uppercase',
  display: 'inline-block',
  marginLeft: '5px'
};

revenueStyles['help_revenue'] = {};
revenueStyles['help_revenue'][view.MOBILE] = {
  height: '15px',
  position: 'absolute',
  right: '-2px',
  bottom: '5px'
};
revenueStyles['help_revenue'][view.DESKTOP] = {
  height: '18px',
  position: 'absolute',
  right: '-2px',
  bottom: '6px'
};

key = 'clickToSee';
revenueStyles[key] = {};
revenueStyles[key][view.MOBILE] = {
  backgroundColor: 'rgb(214, 242, 224)',
  borderRadius: '2px',
  position: 'relative',
  width: '100%',
  height: '94%'
};
revenueStyles[key][view.DESKTOP] = {
  backgroundColor: 'rgb(214, 242, 224)',
  borderRadius: '2px',
  position: 'relative',
  width: '100%',
  height: '100%'
};

key = 'centerTextRev';
revenueStyles[key] = {};
revenueStyles[key][view.MOBILE] = {
  ...centerAbs,
  width: '100%',
  fontSize: '11px',
  fontWeight: '500',
  opacity: '0.87',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgb(0, 0, 0)'
};
revenueStyles[key][view.DESKTOP] = {
  ...centerAbs,
  fontSize: '13px',
  fontWeight: '500',
  width: '100%',
  opacity: '0.87',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgb(0, 0, 0)'
};

export var revenueStyles;
